// @flow
import React, { useContext } from 'react';
import { FieldArrayGridConfigItemContext } from '@src/formik-utils/FieldArrayGrid';
import { Grid } from 'semantic-ui-react';
import { StyledRowSpecificErrorMessageContainer } from '@presentational/messages/StyledRowSpecificErrorMessageContainer';

export const VBDConflictingRowMessageContainer = ({
  isVBDRow,
  doesVBDRowConflictWithAnyOtherUserRow,
}) => {
  const { columnsConfiguration } = useContext(FieldArrayGridConfigItemContext);

  if (!isVBDRow || !doesVBDRowConflictWithAnyOtherUserRow) {
    return null;
  }

  // Sum up column widths only for non-hidden columns
  const vbdConflictingRowMessageWidth = columnsConfiguration
    .filter((column) => column?.hidden === false)
    .reduce((sum, column) => {
      return sum + column.columnWidth;
    }, 0);

  return (
    <Grid.Row>
      <Grid.Column width={vbdConflictingRowMessageWidth}>
        <StyledRowSpecificErrorMessageContainer
          message="SG discount conflicts with user-defined discount. For conflicts, user-defined discount
            is applied."
        />
      </Grid.Column>
    </Grid.Row>
  );
};
